var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "fill-height justify-center",
      attrs: { id: "editUserProfile", tag: "section" }
    },
    [
      _c(
        "v-card",
        { attrs: { id: "accountSelection", width: "400" } },
        [
          _c("v-card-title", { staticClass: "text-center" }, [
            _vm._v(" " + _vm._s(_vm.$t("editProfile.edit-details")) + " ")
          ]),
          _c("v-card-text", [
            _c(
              "div",
              [
                _c(
                  "v-list",
                  [
                    _c(
                      "v-list-item",
                      { staticClass: "pa-0" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "blue", block: "" },
                            on: { click: _vm.changePassword }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("editProfile.change-password")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      { staticClass: "pa-0" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary", block: "" },
                            on: { click: _vm.returnHome }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("editProfile.return-home")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.showEditPhoneNumberDialog,
            callback: function($$v) {
              _vm.showEditPhoneNumberDialog = $$v
            },
            expression: "showEditPhoneNumberDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(_vm._s(_vm.$t("editProfile.change-phone-number"))),
                _c("br")
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-overlay",
                    {
                      staticClass: "waitoverlay",
                      attrs: { value: _vm.loading }
                    },
                    [
                      _c("v-progress-circular", {
                        staticClass: "mr-4",
                        attrs: { indeterminate: "", size: "64" }
                      }),
                      _vm._v(" " + _vm._s(_vm.waitMessage) + " ")
                    ],
                    1
                  ),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.checkPhoneValidation(
                                    _vm.phoneLength,
                                    _vm.phoneNumber,
                                    _vm.phoneHasNum,
                                    _vm.sub
                                  ),
                                  expression:
                                    "checkPhoneValidation(phoneLength, phoneNumber, phoneHasNum, sub)"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("editProfile.phone-number")) +
                                  " "
                              ),
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "fa fa-exclamation-circle tooltip error"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "editProfile.phone-number-must-have-at-least-11-numbers-and-have-no-letters-parenthis-or-dashes"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              id: "phoneNumber",
                              required: "",
                              rules: [
                                _vm.rules.required,
                                _vm.rules.minPhoneNumber
                              ],
                              placeholder: _vm.$t(
                                "editProfile.phone-number-44-1234-987654"
                              )
                            },
                            on: {
                              focus: _vm.showphonenumberrequirements,
                              input: _vm.removeNonDigitCharacters
                            },
                            model: {
                              value: _vm.phoneNumber,
                              callback: function($$v) {
                                _vm.phoneNumber = $$v
                              },
                              expression: "phoneNumber"
                            }
                          }),
                          _c(
                            "ul",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.disphoner === true,
                                  expression: "disphoner === true"
                                }
                              ]
                            },
                            [
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.phoneLength === false,
                                      expression: "phoneLength === false"
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "editProfile.phone-number-must-be-11-numbers-long"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.phoneHasNum === false ||
                                        _vm.phoneNumber === "",
                                      expression:
                                        "phoneHasNum === false || phoneNumber === ''"
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "editProfile.phone-number-must-contain-only-numbers"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.error
                    ? _c("div", { staticClass: "phonenumbererror" }, [
                        _vm._v(" " + _vm._s(_vm.error)),
                        _c("br")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c("v-btn", { on: { click: _vm.closePhoneNumberDialog } }, [
                    _vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid, color: "red" },
                      on: { click: _vm.changePhoneNumber }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("editProfile.update")) + " ")]
                  ),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.showChangePasswordDialog,
            callback: function($$v) {
              _vm.showChangePasswordDialog = $$v
            },
            expression: "showChangePasswordDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(_vm._s(_vm.$t("editProfile.change-password"))),
                _c("br")
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-overlay",
                    {
                      staticClass: "waitoverlay",
                      attrs: { value: _vm.loading }
                    },
                    [
                      _c("v-progress-circular", {
                        staticClass: "mr-4",
                        attrs: { indeterminate: "", size: "64" }
                      }),
                      _vm._v(" " + _vm._s(_vm.waitMessage) + " ")
                    ],
                    1
                  ),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      model: {
                        value: _vm.validPassword,
                        callback: function($$v) {
                          _vm.validPassword = $$v
                        },
                        expression: "validPassword"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("editProfile.change-password-instructions")
                          )
                        )
                      ]),
                      _c("password-set-fields", {
                        on: { "password-change": _vm.updatePassword }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { on: { click: _vm.closeChangePasswordDialog } },
                    [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red", disabled: !_vm.validPassword },
                      on: { click: _vm.changePasswordSumbit }
                    },
                    [_vm._v(" Update ")]
                  ),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: 5000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.$t("editProfile.phone-number-updated")) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }